import { BaseModel } from './util';

export enum LeagueFieldTypes {
  text = 1,
  select,
  file,
}

export class LeagueFieldBase extends BaseModel {
  private _variantsMapping = {};
  private _variants = [];

  id: number;
  leagueId: number;
  name: string;
  type: LeagueFieldTypes;
  isMultiple: boolean;
  sort: number;

  set variants(value: { uuid: string, name: string }[]) {
    this._variants = value;
    this._variantsMapping = value.reduce((acc, item) => ({
      ...acc,
      [item.uuid]: item.name
    }), {});
  }

  get variants(): {uuid: string, name: string}[] {
    return this._variants;
  }

  getName(uuid: string): string {
    return this._variantsMapping[uuid];
  }
}
